import { SearchResultItem } from '@smart-tv/typings/search';

import { kmm } from './kmm';
import { toKmmSearchResultItem } from './search-helpers';

export async function removeFromSearchHistory(item: SearchResultItem): Promise<boolean> {
  return kmm((repo) => repo.removeFromSearchHistory(toKmmSearchResultItem(item)));
}

export default removeFromSearchHistory;
